import React from 'react';
import dateFormat from 'dateformat';

import { CalendarView } from './dcalendar';
import Cross from '../../../icons/Cross';
import formatPrice from '@ibibo/format-price';
import * as S from './destination-cal.styles';
const maxAllowedRoomNights = 20;

const CalendarBlock = React.forwardRef(
  (
    props: {
      isSearchWidget;
      isDeparture;
      isArrival;
      onSelection;
      handleOnDateClick;
      departure;
      getFareData;
      calendarDateChanged;
      fareCalendarData;
      isVisibleCalendar;
      setVisibleCalendar;
    },
    ref
  ) => {
    const {
      isSearchWidget,
      isDeparture,
      isArrival,
      onSelection,
      handleOnDateClick,
      departure,
      getFareData,
      calendarDateChanged,
      fareCalendarData,
      isVisibleCalendar,
      setVisibleCalendar
    } = props;

    const todaysDate = new Date();
    const maxDateAllowed = new Date();
    maxDateAllowed.setMonth(maxDateAllowed.getMonth() + 12);
    if (isArrival) {
      maxDateAllowed.setDate(maxDateAllowed.getDate() + maxAllowedRoomNights);
    }

    const calMinPriceOfMonth = dateObj => {
      let minPriceOfMonth = Infinity;
      let currentDateObj = new Date(dateObj);

      for (let i = 0; currentDateObj.getMonth() === dateObj.getMonth(); i++) {
        const { data = null, stats = null } = fareCalendarData || {};
        const yyyymmdd = dateFormat(dateObj, 'yyyymmdd');

        let price = 0;
        if (data && data[yyyymmdd]) {
          price = data[yyyymmdd].p;
          if (price && price < minPriceOfMonth) {
            minPriceOfMonth = price;
          }
        }
        dateObj.setDate(dateObj.getDate() + 1);
      }
      return minPriceOfMonth;
    };

    const closeCalendar = () => {
      setVisibleCalendar(false);
    };

    const displayCalendar = () => {
      setVisibleCalendar(true);
    };

    const MONTHS = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC'
    ];

    let currentMonth = new Date().getMonth();
    let departureMonth = departure?.dateObj?.getMonth();
    let departureDate = new Date(departure?.dateObj);

    if (currentMonth !== departureMonth) {
      currentMonth = departureMonth - 1;
      const departureYear = departure?.dateObj?.getFullYear();
      departureDate = new Date(departureYear, currentMonth, 1);
    }

    let calendarDates = [];
    let minPriceOfMonths = [];
    calendarDates.push(departureDate);
    minPriceOfMonths.push(calMinPriceOfMonth(new Date(departureDate)));

    for (let i = 0; i < 3; i++) {
      let month = departureDate.getMonth(),
        year = departureDate.getFullYear();

      if (month === 11) {
        departureDate = new Date(year + 1, 0, 1);
      } else {
        departureDate = new Date(year, month + 1, 1);
      }
      calendarDates.push(departureDate);
      minPriceOfMonths.push(calMinPriceOfMonth(new Date(departureDate)));
    }

    return (
      <>
        <S.DestinationCalOuter>
          <span className="dateTag quicksand" onMouseOver={displayCalendar}>
            {departure && departure.dateToDisplay}
          </span>
          {isVisibleCalendar ? (
            <div className="destCal">
              <S.CalendarSection>
                <Cross
                  onClick={closeCalendar}
                  width="1.2rem"
                  height="1.2rem"
                  style={{ position: 'absolute', right: 0, margin: '1.2rem', opacity: '0.5' }}
                />
                <S.CalSecHead>
                  {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </S.CalSecHead>
                <S.CalSecContent>
                  <S.CalBlock>
                    {calendarDates.map((date, ind) => {
                      return (
                        <CalendarView
                          key={ind}
                          dateConfigForMonthToBeDisplayed={date}
                          monthName={MONTHS[date.getMonth()]}
                          cheapestMonth={MONTHS[departure?.dateObj.getMonth()]}
                          minPriceOfMonth={minPriceOfMonths[ind]}
                          minDateAllowed={isDeparture ? todaysDate : departure.dateObj}
                          maxDateAllowed={maxDateAllowed}
                          extendedComponent={null}
                          renderDateItem={({ value, dateObj, index }) => {
                            const { data = null, stats = null } = fareCalendarData || {};
                            const yyyymmdd = dateFormat(dateObj, 'yyyymmdd');

                            let price = 0;
                            if (value && data && data[yyyymmdd]) {
                              price = data[yyyymmdd].p;
                            }

                            if (!value) {
                              return (
                                <li
                                  key={index}
                                  style={{ backgroundColor: 'white', border: 'none' }}
                                >
                                  <span></span>
                                </li>
                              );
                            }

                            let isValid = false;

                            dateObj.setHours(0, 0, 0, 0);
                            todaysDate.setHours(0, 0, 0, 0);
                            isValid =
                              dateObj.getTime() >= todaysDate.getTime() &&
                              dateObj.getTime() < maxDateAllowed.getTime();

                            const isSelected = departure.dateObj.getTime() === dateObj.getTime();

                            return (
                              <ul key={index}>
                                <li
                                  className={`${
                                    price == minPriceOfMonths[ind] ? 'lowestFare' : null
                                  } ${isSelected ? 'preselected' : ''}`}
                                  style={
                                    isValid
                                      ? { color: 'black', cursor: 'pointer' }
                                      : {
                                          opacity: '0.4',
                                          color: 'grey',
                                          pointerEvents: 'none'
                                        }
                                  }
                                  onClick={() => {
                                    isValid && calendarDateChanged(new Date(dateObj));
                                  }}
                                  key={index}
                                >
                                  <p className="calDaytext">{value}</p>
                                  <p className="calPricetext">{price ? formatPrice(price) : '-'}</p>
                                </li>
                              </ul>
                            );
                          }}
                        />
                      );
                    })}
                  </S.CalBlock>
                </S.CalSecContent>
              </S.CalendarSection>
            </div>
          ) : null}
        </S.DestinationCalOuter>
        <S.Overlay className="overlay"></S.Overlay>
      </>
    );
  }
);

export default CalendarBlock;
